import { formatDate } from '@angular/common';
import { Component, OnInit, OnDestroy, Inject, ViewChild, ElementRef, Renderer2, RendererFactory2, ChangeDetectionStrategy } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { DataService } from './services/DataService';
import { AlertService } from './_alert';
import { ConfigService } from './models/ConfigService';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'msal-angular-tutorial';
  isIframe = false;
  loginDisplay = false;
  @ViewChild("myDiv", { static: false }) divView: ElementRef;
    //@ViewChild("scrollMe", { static: true }) scroll: ScrollToBottomDirective;
    @ViewChild('scrollMe', { static: true }) scroll: any;




    ngAfterViewInit() {
      //  this.scroll.nativeElement.scrollTo(0, this.scroll.nativeElement.scrollHeight);

    }
   
    fname = "";
    show_aq_JobProfileMatching:boolean =false;
    showlandingJobProfile:boolean=false
    dropdownSettings: IDropdownSettings = {};
    SentimentSettings: IDropdownSettings = {};
    data: string;
    cntrForChart: any = 0;
    Decisiondata: any = 0;
    checkchange: any;
    ShowHealthWBnew:boolean=false;
    Userdata : any = "";
    powerbi:boolean=false;  
    private storage: any;
    private renderer: Renderer2;
    cntuserData: number = 0;
    SelectedSentiments: string = "";
    Sentimentdisabled: boolean = true;
    showDec: boolean = false;
    showCharts: boolean = false;
   
    showHome: boolean = false;
    showQues: boolean = false;
    ShowHealthWB:boolean=false;
    showUserData: boolean = false;
    showTextAnalysis: boolean = true;
    showJobProfileMatching:boolean=false;
    showSpeechTagging:boolean=false;
    showTextSummarizer:boolean=false;
    showWordCloud:boolean=false;
    showSentimentAnalysis:boolean=false;
    showThemeGenerate:boolean=false;
    showChatBot: string = "none";
    FilterWidthMarginPosition = { x: '0px', y: '0px' };
    SelFilter = '0';
    DisplayDvloaderForFilter = 'none';
    FilterList:any;
    //dropdownList = [{ "SelDropdown": "", "SelectedList":[], "selectedItems":[], "ShowDelete": true, "FilterType": "HRDefine" }];
    dropdownList : any=[];
    selectedItems : any = [];
    AddedNewFilter = [];
    ChatBotStyles: any;
    DisplayMesgs: string = "none";
    DisplayTypeMsg: string = "none";
    today: number = Date.now();
    mdlSampleIsOpen: boolean = false;
    MarketLocationList = [];
    ChartStyles: any;
    LoaderForChatBot: string = "none";
    SaveQuery: string;
    SeltextVal: string;
    tmpDemographicList: any;
    ArrSelDemo : any = [];
    ShowDelete: boolean = true;
    selectedTypeVar: string;
    a_InnerHtml = "See more";
    SentimentList :any;
    UserData: boolean = false;
    showUserTopicModelling: boolean = false;
    RecivedToken :any;
    ShowLoader :string = "none";
   
 



  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, 
    private broadcastService: MsalBroadcastService, 
    private authService: MsalService,
    private api: DataService,
    protected alertService: AlertService,
    private rendererFactory: RendererFactory2,
    private msalBroadcastService: MsalBroadcastService,
    private conf : ConfigService ) 
    {
      this.renderer = rendererFactory.createRenderer(null, null);
      this.storage = sessionStorage;
     }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;

    this.broadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this._destroying$)
    )
    .subscribe(() => {
      this.setLoginDisplay();
    })
  }

  login() {
    if (this.msalGuardConfig.authRequest){
      this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
      this.Userdata = "ChartData";
    } else {
      this.authService.loginRedirect();
    }
    
  }

  returnusername(){
     
    return this.authService.instance.getAllAccounts()[0].name;
  }

  returnToken()
  {
    let tmp = this.authService.instance.getAllAccounts()[0]
    let homeAccountID = tmp.homeAccountId  + "-" + tmp.environment + this.conf.getSettings("combinekey")  
   
    return homeAccountID;
  }
  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    
  
    if(this.loginDisplay == false){
      this.login();
      
    }
    else{
       // this.acquireToken();
    }
    
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  



//   Show and Hide DIVS
ShowDiv(divName: string) {
    if (divName == 'Segment') {
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showDec = true;
        this.showCharts = false;
        this.showQues = false;
        this.showChatBot = "none";
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.Userdata = "SegmentData";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
        this.ShowHealthWB=false;
        this.powerbi=false;
        this.ShowHealthWBnew=false;
    }
    else if (divName == 'Charts') {
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = true;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.Userdata = "ChartData";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
        this.ShowHealthWBnew=false;
        // this.ChatBotStyles = {
        //     'height': '500px',
        //     'left': '0%',
        //     'width': '25%'
        // }
        // this.ChartStyles = {
        //     'marginLeft': '23%' ThemeGenerate
        // }

    }
    else if (divName == 'Home') {
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = true;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.FilterWidthMarginPosition.x = '0px';
        this.FilterWidthMarginPosition.y = '0px';
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
        this.ShowHealthWBnew=false;

    }
    else if (divName == 'Ques') {
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showQues = true;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.showUserData = false;
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showUserTopicModelling = false;
        this.FilterWidthMarginPosition.x = '0px';
        this.FilterWidthMarginPosition.y = '0px';
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.ShowHealthWBnew=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
        this.ChatBotStyles = {
            'height': '500px',
            'right': '0%'
        }
        this.DisplayMesgs = "block";
        this.DisplayTypeMsg = "block";
        let todaysDataTime = formatDate(this.today, 'dd-MM-yyyy hh:mm:ss a', 'en-US', '+0530');
        let username = this.returnusername;
        //let username = "isha tyagi"
        if (this.showChatBot == "none") {
            let str = document.getElementsByClassName("msg_history")[0];
            if (str.innerHTML == "") {
                const MainboxTextCMsg: HTMLDivElement = document.createElement("div");
                MainboxTextCMsg.className = "outgoing_msg";

                const boxTextCMsg: HTMLDivElement = document.createElement("div");
                boxTextCMsg.className = "sent_msg";

                const PyesCMsg: HTMLParagraphElement = document.createElement('p');
                PyesCMsg.innerHTML = "Hello " + username + ", welcome.";

                boxTextCMsg.appendChild(PyesCMsg);

                const PyesCMsgNext: HTMLParagraphElement = document.createElement('p');
                PyesCMsgNext.innerHTML = 'I am SAM (Self service analytics module), who is here to make your journey with "HR Analytics" great and enriching. You can ask me HR analytical questions. The more questions you ask, the smarter I get.';

                boxTextCMsg.appendChild(PyesCMsgNext);

                const SpanText = document.createElement("span");
                SpanText.innerHTML = todaysDataTime;
                SpanText.className = "time_date";

                boxTextCMsg.appendChild(SpanText);
                MainboxTextCMsg.append(boxTextCMsg);

                this.renderer.appendChild(this.divView.nativeElement, MainboxTextCMsg);
            }
            this.showChatBot = "block";
            this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollHeight;
        }
    }
    else if (divName == 'UserData') {
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.ShowHealthWBnew=false;
        this.showUserData = true;
        this.showUserTopicModelling = false;
        this.FilterWidthMarginPosition.x = '0px';
        this.FilterWidthMarginPosition.y = '0px';
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;

    }
    else if (divName == 'TopicModelling') {
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.ShowHealthWBnew=false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = true;
        this.FilterWidthMarginPosition.x = '0px';
        this.FilterWidthMarginPosition.y = '0px';
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
    }
    else if(divName == 'TextAnalysis'){
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.ShowHealthWBnew=false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=true;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
    }
    else if(divName=='JobProfileMatching'){
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.ShowHealthWBnew=false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showJobProfileMatching=true;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
    }
    else if(divName == 'aq-JobProfileMatching'){
        this.powerbi=false;
        this.ShowHealthWBnew=false;
        this.ShowHealthWB=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching = true;
     
        this.showHome = false;
        this.showThemeGenerate=false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showTextAnalysis=false;
        this.showJobProfileMatching=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        //this.show_aq_JobProfileMatching =false;
    }
    else if(divName=='landingjobprofile'){
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.ShowHealthWBnew=false;
        this.showHome = false;
        this.showlandingJobProfile =true;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
        this.show_aq_JobProfileMatching=false;
        
    }
    else if(divName=='TextSummarizer'){
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.ShowHealthWBnew=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=true;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
    }
    else if(divName=='SpeechTagging'){
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.ShowHealthWBnew=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=true;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
    }
    else if(divName=='WordCloud'){
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.ShowHealthWBnew=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=true;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
    }
    else if(divName=='SentimentAnalysis'){
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.ShowHealthWBnew=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=true;
        this.showThemeGenerate=false;
    }
    else if(divName=='ThemeGenerate'){
        this.powerbi=false;
        this.ShowHealthWB=false;
        this.ShowHealthWBnew=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=true;
        console.log('Theme called')
    }
    else if(divName=='hwmain'){
        this.powerbi=false;
        this.ShowHealthWBnew=false;
        this.ShowHealthWB=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
        this.ShowHealthWB=true;
        console.log('Health called')

    }
    else if(divName=='hwmainnew'){
        this.powerbi=false;
        this.ShowHealthWBnew=true;
        this.ShowHealthWB=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
        this.ShowHealthWB=false;
        console.log('Health new called')

    }
    else if(divName=='powerbi'){
        this.ShowHealthWBnew=false;
        this.ShowHealthWB=false;
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;
        this.showHome = false;
        this.showCharts = false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showChatBot = "none";
        this.showJobProfileMatching=false;
        this.showTextAnalysis=false;
        this.showWordCloud=false;
        this.showSpeechTagging=false;
        this.showTextSummarizer=false;
        this.showSentimentAnalysis=false;
        this.showThemeGenerate=false;
        this.ShowHealthWB=false;
        this.powerbi=true;
        console.log('power')

    }
    else {
        this.ShowHealthWB=false;
        this.showHome = false;
        this.ShowHealthWBnew=false;
        this.showTextAnalysis = true;
        this.showCharts = false;
        this.showThemeGenerate=false;
        //this.showtheme=false;
        this.showDec = false;
        this.showQues = false;
        this.showUserData = false;
        this.showUserTopicModelling = false;
        this.showWordCloud=false;
        this.showSentimentAnalysis=false;
        this.FilterWidthMarginPosition.x = '0px';
        this.FilterWidthMarginPosition.y = '0px';
        this.showChatBot = "none";
        this.showlandingJobProfile =false;
        this.show_aq_JobProfileMatching=false;

    }
}

ApplyFilters() {

    if ((this.showCharts == true) && (this.showDec == false)) {
        //console.log('hfjghkl',this.cntrForChart );
        this.cntrForChart = this.cntrForChart + 1;
        // console.log('hfjghklguyu',this.cntrForChart );
        this.checkchange = "Changefromfilter";
        // this.startChat(this.SaveQuery, '', 0);
    }
    
    else if ((this.showDec == true) && (this.showCharts == false)) {
        this.Decisiondata = this.Decisiondata + 1;

    }
    else {
        this.Decisiondata = this.Decisiondata + 1;

        this.ShowDiv('Segment');
    }
}


//Show and Hide Filters
ShowFilter() {

    if (this.FilterWidthMarginPosition.x == "0px") {
        this.FilterWidthMarginPosition.x = '230px';
        this.FilterWidthMarginPosition.y = '230px';
        this.ChartStyles = { 'marginLeft': '0%' };
        this.DisplayMesgs = "none";
        this.DisplayTypeMsg = "none";
        this.ChatBotStyles = {
            'height': '50px',
            'left': '0%',
            'width': '25%'
        }
    }
    else {
        this.FilterWidthMarginPosition.x = '0px';
        this.FilterWidthMarginPosition.y = '0px';
        this.DisplayMesgs = "block";
        this.DisplayTypeMsg = "block";
        this.ChatBotStyles = {
            'height': '500px',
            'left': '0%',
            'width': '25%'
        }
        this.ChartStyles = {
            'marginLeft': '25%'
        }
    }
}




//Bind Filters dropdown
BindFilters(chart_type: string) {
    // let storagekey = this.returnToken();
   
    // let auth_token = JSON.parse(this.storage[storagekey]);
    
    // auth_token = auth_token.secret ;
    let auth_token = "";
    

    
    let attritiontype;
    this.UserData = false;
    if (chart_type.toLowerCase() == 'combo') {
        attritiontype = 'attrition';
        this.selectedTypeVar = attritiontype;
    }
    else {
        attritiontype = 'pto';
        this.selectedTypeVar = attritiontype;
    }
    this.api.GetDataForDropDowns(auth_token, attritiontype)
        .subscribe((result: any) => {

            this.FilterList = result.textData;
            
        },

            (error: any) => {
                
                //window.location.reload();
                
            }
        );


}



//check count of filters applied and same filetrs should not be selected
GetFilterIcon() {

    var chkFilter = 0;
    let Filtervalue = this.SelFilter.split('^')[0];
    let Filtertext = this.SelFilter.split('^')[1];
    for (var z = 0; z < this.dropdownList.length; z++) {
        if (Filtervalue == this.dropdownList[z].SelDropdown) {

            chkFilter = 1;
            break;
        }

    }


    if (chkFilter == 1) {

        this.alertService.error('Filter Is Already Applied', { id: 'alert-1' });
    }
    else {
        if (this.dropdownList.length < 10) {
            
                this.ajaxddfunction(this.SelFilter);
            
        }
        else {
            this.alertService.error('Total Number of filter limit is crossed', { id: 'alert-1' });
        }
    }
}

//add selected filter to screen
ajaxddfunction(filterIcon: string) {
    this.DisplayDvloaderForFilter = 'block';
    var Userkey = "";
    for (var i = 0; i < this.dropdownList.length; i++) {
        var selitems = "";
        if (this.dropdownList[i].selectedItems.length > 0) {
            for (var p = 0; p < this.dropdownList[i].selectedItems.length; p++) {

                selitems += this.dropdownList[i].selectedItems[p].col_name + ":";

            }
            selitems = selitems.slice(0, -1)
            Userkey += this.dropdownList[i].SelDropdown + "~" + selitems + ";";

        }

    }
    Userkey = Userkey.slice(0, -1);
    let storagekey = this.returnToken();
    let Filtervalue = this.SelFilter.split('^')[0];
    let Filtertext = this.SelFilter.split('^')[1];
    // let auth_token = JSON.parse(this.storage[storagekey]);
    
    // auth_token = auth_token.secret ;
    let auth_token = "";
    
    this.api.GetDataForFilters(auth_token, Filtervalue, Userkey, this.selectedTypeVar)
        .subscribe((result: any) => {

            this.DisplayDvloaderForFilter = 'none';
            this.AddedNewFilter = result.DataWithoutFilter;
            this.selectedItems = [];
            this.ShowDelete = true;
            this.dropdownList.push({ "SelDropdown": Filtervalue, "SelectedList": this.AddedNewFilter, "selectedItems": this.selectedItems, "ShowDelete": this.ShowDelete, "FilterType": "HRDefine","DropdownText": Filtertext })


            this.dropdownSettings = {
                singleSelection: false,
                idField: 'col_name',
                textField: 'col_name',
                selectAllText: 'Select All',
                unSelectAllText: 'UnSelect All',
                itemsShowLimit: 1,
                allowSearchFilter: true
            };
        },

            (error) => {
                var errorMsg=error.error.DataWithoutFilter.toLowerCase();
                if(errorMsg.includes('unrecognized name')){
                    this.alertService.error('There is some issue with selected filters! Please try with some different combination of filters.', { id: 'alert-1' }); 
                }
                this.DisplayDvloaderForFilter = 'none';
            }
        );
}

//add selected filter
onItemSelect(item: any, selfil: string) {
    var tmpFilter = [];
    var tmpindex = 0;

    for (var i = 0; i < this.dropdownList.length; i++) {
        if (selfil == this.dropdownList[i].SelDropdown) {
            tmpindex = i + 1;
            break;

        }
    }

    if (this.showUserData == true) {
        for (var i = tmpindex; i < this.dropdownList.length; i++) {
            tmpFilter.push({ "SelDropdown": this.dropdownList[i].SelDropdown, "SelectedList": this.dropdownList[i].SelectedList, "selectedItems": this.dropdownList[i].selectedItems, "ShowDelete": this.ShowDelete, "FilterType": "UserDefine","DropdownText": this.dropdownList[i].Filtertext })

        }
    }
    else {


        for (var i = tmpindex; i < this.dropdownList.length; i++) {
            tmpFilter.push({ "SelDropdown": this.dropdownList[i].SelDropdown, "SelectedList": this.dropdownList[i].SelectedList, "selectedItems": this.dropdownList[i].selectedItems, "ShowDelete": this.ShowDelete, "FilterType": "HRDefine" ,"DropdownText": this.dropdownList[i].Filtertext})

        }
    }


    this.UpdateRemainingFilter(tmpFilter);
}

//add all selected filter
onSelectAll(items: any, selfil: string, type: string) {

    for (var z = 0; z < this.dropdownList.length; z++) {
        if (selfil == this.dropdownList[z].SelDropdown) {
            this.dropdownList[z].selectedItems = [];
            if (type == 'selectAll') {
                for (var q = 0; q < items.length; q++) {
                    this.dropdownList[z].selectedItems.push(items[q]);
                }
            }
            break;

        }
    }


    var tmpFilter = [];
    var tmpindex = 0;

    for (var i = 0; i < this.dropdownList.length; i++) {
        if (selfil == this.dropdownList[i].SelDropdown) {
            tmpindex = i + 1;
            break;

        }
    }
    if (this.showUserData == true) {
        for (var i = tmpindex; i < this.dropdownList.length; i++) {
            tmpFilter.push({ "SelDropdown": this.dropdownList[i].SelDropdown, "SelectedList": this.dropdownList[i].SelectedList, "selectedItems": this.dropdownList[i].selectedItems, "ShowDelete": this.ShowDelete, "FilterType": "UserDefine" ,"DropdownText": this.dropdownList[i].Filtertext})

        }
    }
    else {
        for (var i = tmpindex; i < this.dropdownList.length; i++) {
            tmpFilter.push({ "SelDropdown": this.dropdownList[i].SelDropdown, "SelectedList": this.dropdownList[i].SelectedList, "selectedItems": this.dropdownList[i].selectedItems, "ShowDelete": this.ShowDelete, "FilterType": "HRDefine","DropdownText": this.dropdownList[i].Filtertext })

        }
    }
    // this.Decisiondata = "select all";
    this.UpdateRemainingFilter(tmpFilter);
}

//delete filters
DeleteFilter(selfil: string) {
    var tmpFilter = [];
    var tmpindex = 0;
    for (var i = 0; i < this.dropdownList.length; i++) {
        if (selfil == this.dropdownList[i].SelDropdown) {
            this.dropdownList.splice(i, 1);
            tmpindex = i;
            break;

        }
    }


    if (this.showUserData == true) {
        for (var i = tmpindex; i < this.dropdownList.length; i++) {
            tmpFilter.push({ "SelDropdown": this.dropdownList[i].SelDropdown, "SelectedList": this.dropdownList[i].SelectedList, "selectedItems": this.dropdownList[i].selectedItems, "ShowDelete": this.ShowDelete, "FilterType": "UserDefine" ,"DropdownText": this.dropdownList[i].Filtertext})

        }
    }
    else {
        for (var i = tmpindex; i < this.dropdownList.length; i++) {
            tmpFilter.push({ "SelDropdown": this.dropdownList[i].SelDropdown, "SelectedList": this.dropdownList[i].SelectedList, "selectedItems": this.dropdownList[i].selectedItems, "ShowDelete": this.ShowDelete, "FilterType": "HRDefine" ,"DropdownText": this.dropdownList[i].Filtertext})

        }
    }

    // for (var i = tmpindex; i < this.dropdownList.length; i++) {
    //     tmpFilter.push({ "SelDropdown": this.dropdownList[i].SelDropdown, "SelectedList": this.dropdownList[i].SelectedList, "selectedItems": this.dropdownList[i].selectedItems })

    // }
    //console.log(tmpFilter,"465");
    // this.Decisiondata = "deselect all"
    this.UpdateRemainingFilter(tmpFilter);
}


//Update remaining filters
UpdateRemainingFilter(Arr: string | any[]) {


    for (var q = 0; q < Arr.length; q++) {
        var Userkey = "";
        var tmpselDropDown = "";
        this.DisplayDvloaderForFilter = 'block';
        let chkUserType = ""
        for (var i = 0; i < this.dropdownList.length - 1; i++) {
            var selitems = "";
           
            if (this.dropdownList[i].selectedItems.length > 0) {
                for (var p = 0; p < this.dropdownList[i].selectedItems.length; p++) {

                    selitems += this.dropdownList[i].selectedItems[p].col_name + ":";
                    chkUserType = this.dropdownList[i].FilterType;

                }
                selitems = selitems.slice(0, -1)
                if (this.dropdownList[i].SelDropdown == Arr[q].SelDropdown) {
                    tmpselDropDown = Arr[q].SelDropdown;

                    break;
                }
                else {
                    Userkey += this.dropdownList[i].SelDropdown + "~" + selitems + ";";
                }


            }


        }
        Userkey = Userkey.slice(0, -1);
       // console.log("563", chkUserType);

       let storagekey = this.returnToken();
   
    let auth_token = "";
    
    //auth_token = auth_token.secret ;
    let Filtervalue = this.SelFilter.split('^')[0];
    let Filtertext = this.SelFilter.split('^')[1];

        if (chkUserType == "UserDefine") {
            this.api.GetDataForFiltersForUser(auth_token, Filtervalue, Userkey, this.fname)
                .subscribe((result: any) => {


                    this.DisplayDvloaderForFilter = 'none';
                    this.AddedNewFilter = result.DataWithoutFilter;
                    for (var z = 0; z < this.dropdownList.length; z++) {

                        if (result.SelCol == this.dropdownList[z].SelDropdown) {

                            this.dropdownList[z].SelectedList = result.DataWithoutFilter;
                            break;
                        }

                    }
                },

                    (error) => {
                        this.DisplayDvloaderForFilter = 'none';
                    }
                );
        }
        else {
            this.api.GetDataForFilters(auth_token, Arr[q].SelDropdown, Userkey, this.selectedTypeVar)
                .subscribe((result: any) => {

                    this.DisplayDvloaderForFilter = 'none';
                    this.AddedNewFilter = result.DataWithoutFilter;
                    for (var z = 0; z < this.dropdownList.length; z++) {

                        if (result.SelCol == this.dropdownList[z].SelDropdown) {

                            this.dropdownList[z].SelectedList = result.DataWithoutFilter;
                            break;
                        }

                    }
                    //this.dropdownList.push({"SelDropdown":this.SelFilter,"SelectedList":this.AddedNewFilter,"selectedItems": this.selectedItems})

                },

                    (error) => {
                        var errorMsg=error.error.DataWithoutFilter.toLowerCase();
                        if(errorMsg.includes('unrecognized name')){
                            this.alertService.error('There is some issue with selected filters! Please try with some different combination of filters.', { id: 'alert-1' }); 
                        }
                        this.DisplayDvloaderForFilter = 'none';
                    }
                );
        }
    }
}


//Calculate and apply filters
CalculateFilters(): string {
    var Userkey = "";
    for (var i = 0; i < this.dropdownList.length; i++) {
        var selitems = "";
        if (this.dropdownList[i].selectedItems.length > 0) {
            for (var p = 0; p < this.dropdownList[i].selectedItems.length; p++) {

                selitems += this.dropdownList[i].selectedItems[p].col_name + ":";

            }
            selitems = selitems.slice(0, -1)
            Userkey += this.dropdownList[i].SelDropdown + "~" + selitems + ";";

        }

    }
    Userkey = Userkey.slice(0, -1);
    return Userkey;
}








toTitleCase(value: string) {
    let first = value.substr(0, 1).toUpperCase();
    return first + value.substr(1);
}

//Calculate and apply filters
AppendFiltersValue(): string {
    var Userkey = "";
    for (var i = 0; i < this.dropdownList.length; i++) {
        var selitems = "";
        if (this.dropdownList[i].selectedItems.length > 0) {
            for (var p = 0; p < this.dropdownList[i].selectedItems.length; p++) {

                selitems += this.dropdownList[i].selectedItems[p].col_name + ";";

            }
            selitems = selitems.slice(0, -1)
            Userkey += '<b>' + this.dropdownList[i].SelDropdown + ": </b>" + selitems + "<br/>";

        }

    }
    Userkey = Userkey.slice(0, -1);
    return Userkey;
}







 //Populate chart when click on question
 PopulateChat(Question: any) {
    this.today = Date.now();
    let Chattext = Question.replace(/[_,]+/g, " ").replace("~", "'");
    console.log(Chattext);
    let todaysDataTime = formatDate(this.today, 'dd-MM-yyyy hh:mm:ss a', 'en-US', '+0530');



    const MainboxTextCMsg: HTMLDivElement = document.createElement("div");
    MainboxTextCMsg.className = "incoming_msg";

    const boxTextCMsg: HTMLDivElement = document.createElement("div");
    boxTextCMsg.className = "incoming_msg_img";

    const IText = document.createElement("span");
    IText.className = "material-icons";
    IText.innerText = "person";

   

    boxTextCMsg.appendChild(IText);

    MainboxTextCMsg.appendChild(boxTextCMsg);


    const boxTextCMsgmain: HTMLDivElement = document.createElement("div");
    boxTextCMsgmain.className = "received_msg";


    const boxTextCMsgmainInside: HTMLDivElement = document.createElement("div");
    boxTextCMsgmainInside.className = "received_withd_msg";

    const PText = document.createElement("p");
    PText.innerHTML = Chattext;

    boxTextCMsgmainInside.appendChild(PText);

    const SpanText = document.createElement("span");
    SpanText.innerHTML = todaysDataTime;
    SpanText.className = "time_date";

    boxTextCMsgmainInside.appendChild(SpanText);

    boxTextCMsgmain.appendChild(boxTextCMsgmainInside);

    MainboxTextCMsg.appendChild(boxTextCMsgmain);


    this.renderer.appendChild(this.divView.nativeElement, MainboxTextCMsg);


    //this.TextMsg +=div
    this.SaveQuery = Chattext;
    this.SelFilter = "0";
    this.dropdownList = [];
    this.ArrSelDemo = [];
    this.startChat(Chattext, '', 0)
}


//start chat
startChat(Chattext: any, Front_input : any, Flag : any) {
    this.checkchange = "NochangeRequired";
    let auth_token="";
    
    let todaysDataTime = formatDate(this.today, 'dd-MM-yyyy hh:mm:ss a', 'en-US', '+0530');
    this.LoaderForChatBot = "block";
    this.api.startChat(auth_token, Chattext, Front_input, Flag)
        .subscribe((result: any) => {
            this.data = result;
            

            for (var p = this.dropdownList.length - 1; p >= 0; p--) {
                if ((this.dropdownList[p].FilterType != "Demographic")) {

                    this.dropdownList.splice(p, 1);


                }
            }



            //Returns result for the query but ask user to select market unit location for the selection
            if ((result.Response.HR_flag == 3) || (result.Response.HR_flag == 5)) {
                this.BindFilters(result.Response.chart_type);
                let chkMUC = 0;
                if (result.Response.filter_var.split(";") != 'NA') {
                    let FilterName = result.Response.filter_var.split(";");
                    let FilterValue = result.Response.filter_val.split(";");

                    for (var i = 0; i < FilterName.length; i++) {
                        this.SelFilter = this.toTitleCase(FilterName[i]);
                        //console.log("608", this.SelFilter);
                        let tmpFilterValue = FilterValue[i].split("~");

                        let eachFilterValue = [];
                        for (var z = 0; z < tmpFilterValue.length; z++) {

                            eachFilterValue.push({ "col_name": tmpFilterValue[z], "isDisabled": true });
                        }
                        this.ShowDelete = true;

                        this.dropdownList.push({ "SelDropdown": this.SelFilter, "SelectedList": eachFilterValue, "selectedItems": eachFilterValue, "ShowDelete": this.ShowDelete, "FilterType": "DirectQues" })
                        //this.GetFilterIcon();
                        this.dropdownSettings = {
                            singleSelection: false,
                            idField: 'col_name',
                            textField: 'col_name',
                            selectAllText: 'Select All',
                            unSelectAllText: 'UnSelect All',
                            itemsShowLimit: 1,
                            allowSearchFilter: true
                        };
                    }

                    //this.UpdateRemainingFilter(this.dropdownList);
                }
                //this.SelFilter = result.Response.filter_val;
                // this.GetFilterIcon();

                if (this.dropdownList.some((item: { SelDropdown: string; }) => item.SelDropdown === 'Market unit location')) {
                    this.cntrForChart = this.cntrForChart + 1;
                    this.checkchange = "Changefromchatbot";
                    this.ShowDiv('Charts');
                    this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollHeight;
                } else {
                    const MainboxTextCMsg: HTMLDivElement = document.createElement("div");
                    MainboxTextCMsg.className = "outgoing_msg";

                    const boxTextCMsg: HTMLDivElement = document.createElement("div");
                    boxTextCMsg.className = "sent_msg";

                    const PyesCMsg: HTMLParagraphElement = document.createElement('p');
                    PyesCMsg.innerHTML = "Do you want to perform your analysis for specific market unit location";

                    boxTextCMsg.appendChild(PyesCMsg);

                    MainboxTextCMsg.append(boxTextCMsg);

                    this.renderer.appendChild(this.divView.nativeElement, MainboxTextCMsg);


                    const MainboxText: HTMLDivElement = document.createElement("div");
                    MainboxText.className = "outgoing_msg";

                    const boxText: HTMLDivElement = document.createElement("div");
                    boxText.className = "sentMsgOptions";


                    const Pyes: HTMLParagraphElement = document.createElement('p');
                    Pyes.className = "pSentMsgOptions";
                    Pyes.innerHTML = "Yes";
                    Pyes.style.cursor = "pointer";

                    let attritiontype: string;

                    if (result.Response.chart_type.toLowerCase() == 'combo') {
                        attritiontype = 'attrition';
                    }
                    else {
                        attritiontype = 'pto';
                    }
                    Pyes.addEventListener('click', (e) => {
                        this.ShowGeoDTEPopup(e, Chattext, attritiontype);//your typescript function
                    });

                    boxText.appendChild(Pyes);




                    const Pyes1: HTMLParagraphElement = document.createElement('p');
                    Pyes1.className = "pSentMsgOptions";
                    Pyes1.innerHTML = "No";
                    Pyes1.style.cursor = "pointer";
                    Pyes1.addEventListener('click', (e) => {
                        this.HideGeoDTEPopup(e, Chattext, result.Response.Analysis);//your typescript function
                    });

                    boxText.appendChild(Pyes1);

                    const SpanText = document.createElement("span");
                    SpanText.innerHTML = todaysDataTime;
                    SpanText.className = "time_date";

                    boxText.appendChild(SpanText);



                    MainboxText.append(boxText);


                    this.renderer.appendChild(this.divView.nativeElement, MainboxText);
                }

            }
            //Returns result for the most matched questions for the query
            else if ((result.Response.HR_flag == 4) || (result.Response.HR_flag == 2)) {
                if (result.Response.Selkey != undefined) {
                    let FilterName = result.Response.Selkey;

                    for (var i = 0; i < FilterName.length; i++) {
                        this.SelFilter = this.toTitleCase(FilterName[i]);
                        //console.log("712", this.SelFilter);

                        let tmpFilterValue = result.Response[FilterName[i]].split('~');

                        let eachFilterValue = [];
                        for (var z = 0; z < tmpFilterValue.length; z++) {

                            eachFilterValue.push({ "col_name": tmpFilterValue[z], "isDisabled": true });
                        }
                        this.ShowDelete = true;

                        this.dropdownList.push({ "SelDropdown": this.SelFilter, "SelectedList": eachFilterValue, "selectedItems": eachFilterValue, "ShowDelete": this.ShowDelete, "FilterType": "Demographic" })
                        //this.GetFilterIcon();
                        this.dropdownSettings = {
                            singleSelection: false,
                            idField: 'col_name',
                            textField: 'col_name',
                            selectAllText: 'Select All',
                            unSelectAllText: 'UnSelect All',
                            itemsShowLimit: 1,
                            allowSearchFilter: true
                        };
                    }

                    //this.UpdateRemainingFilter(this.dropdownList);
                }


                const MainboxTextCMsg: HTMLDivElement = document.createElement("div");
                MainboxTextCMsg.className = "outgoing_msg";

                const boxTextCMsg: HTMLDivElement = document.createElement("div");
                boxTextCMsg.className = "sent_msg";

                const PyesCMsg: HTMLParagraphElement = document.createElement('p');
                PyesCMsg.innerHTML = "Please select the most relevant query from below options";

                boxTextCMsg.appendChild(PyesCMsg);

                MainboxTextCMsg.append(boxTextCMsg);

                this.renderer.appendChild(this.divView.nativeElement, MainboxTextCMsg);


                const MainboxText: HTMLDivElement = document.createElement("div");
                MainboxText.className = "outgoing_msg";

                const boxText: HTMLDivElement = document.createElement("div");
                boxText.className = "sentMsgOptions";
                boxText.style.width = "60%";

                for (var i = 0; i < result.Response.out_put.length; i++) {
                    const Pyes: HTMLParagraphElement = document.createElement('p');
                    Pyes.className = "pSentMsgOptions bg";
                    Pyes.innerHTML = (result.Response.out_put[i]);
                    Pyes.style.cursor = "pointer";
                    var FrontInput = (result.Response.out_put[i]);

                    Pyes.addEventListener('click', (e) => {
                        this.SelectOneValFromMultipleVal(e, Chattext, FrontInput);

                    });
                    if (i < 4) {
                        Pyes.style.display = "block";
                    }
                    else {
                        Pyes.style.display = "none";
                    }

                    boxText.appendChild(Pyes);
                }

                const Pyes: HTMLParagraphElement = document.createElement('p');
                Pyes.className = "pSentMsgOptions bg";
                Pyes.innerHTML = "None of above";
                Pyes.style.cursor = "pointer";


                Pyes.addEventListener('click', (e) => {
                    this.SelectOneValFromMultipleVal(e, Chattext, "None of above");

                });

                boxText.appendChild(Pyes);

                if (result.Response.out_put.length > 4) {
                    var ahtml: HTMLAnchorElement = document.createElement('a');
                    ahtml.href = "javascript:void(0)";
                    ahtml.className = "a_bg";
                    ahtml.innerHTML = this.a_InnerHtml;
                    ahtml.addEventListener('click', (e) => {
                        //  this.startChat(Chattext, "", 4);//your typescript function
                        this.ShowMoreLess(result.Response.out_put.length, this.a_InnerHtml);
                    });

                    boxText.appendChild(ahtml);
                }

                const SpanText = document.createElement("span");
                SpanText.innerHTML = todaysDataTime;
                SpanText.className = "time_date";

                boxText.appendChild(SpanText);

                MainboxText.append(boxText);


                this.renderer.appendChild(this.divView.nativeElement, MainboxText);


            }
            //Returns result if queries doesn't match any of the questions or demographics
            else if ((result.Response.Query_flag == 3) && (result.Response.HR_flag == 0)) {
                const MainboxTextCMsg: HTMLDivElement = document.createElement("div");
                MainboxTextCMsg.className = "outgoing_msg";

                const boxTextCMsg: HTMLDivElement = document.createElement("div");
                boxTextCMsg.className = "sent_msg";

                const PyesCMsg: HTMLParagraphElement = document.createElement('p');
                PyesCMsg.innerHTML = "I don’t think I got you there. I can try again if you can ask it differently";

                boxTextCMsg.appendChild(PyesCMsg);

                const SpanText = document.createElement("span");
                SpanText.innerHTML = todaysDataTime;
                SpanText.className = "time_date";

                boxTextCMsg.appendChild(SpanText);


                MainboxTextCMsg.append(boxTextCMsg);

                this.renderer.appendChild(this.divView.nativeElement, MainboxTextCMsg);

            }

            //Returns result if demographic doesnot exists in data
            else if ((result.Response.Query_flag == 6) && (result.Response.HR_flag == 0)) {

                const MainboxTextCMsg: HTMLDivElement = document.createElement("div");
                MainboxTextCMsg.className = "outgoing_msg";

                const boxTextCMsg: HTMLDivElement = document.createElement("div");
                boxTextCMsg.className = "sent_msg";

                const PyesCMsg: HTMLParagraphElement = document.createElement('p');
                PyesCMsg.innerHTML = result.Response.out_put;

                boxTextCMsg.appendChild(PyesCMsg);

                const SpanText = document.createElement("span");
                SpanText.innerHTML = todaysDataTime;
                SpanText.className = "time_date";

                boxTextCMsg.appendChild(SpanText);


                MainboxTextCMsg.append(boxTextCMsg);

                this.renderer.appendChild(this.divView.nativeElement, MainboxTextCMsg);
            }
            //Returns result for queries with dashboards
            else if ((result.Response.Query_flag == 7) && (result.Response.HR_flag == 0)) {
                const MainboxTextCMsg: HTMLDivElement = document.createElement("div");
                MainboxTextCMsg.className = "outgoing_msg";

                const boxTextCMsg: HTMLDivElement = document.createElement("div");
                boxTextCMsg.className = "sent_msg";

                const PyesCMsg: HTMLParagraphElement = document.createElement('p');
                PyesCMsg.innerHTML = "In case you are looking for any standard reporting metrics, please refer to below mentioned dashboard. For any HR analytics query, please type in your question or click on below link.";

                boxTextCMsg.appendChild(PyesCMsg);

                MainboxTextCMsg.append(boxTextCMsg);

                this.renderer.appendChild(this.divView.nativeElement, MainboxTextCMsg);


                const MainboxText: HTMLDivElement = document.createElement("div");
                MainboxText.className = "outgoing_msg";

                const boxText: HTMLDivElement = document.createElement("div");
                // boxText.className = "sent_msg";

                const Tbl: HTMLTableElement = document.createElement('table');
                Tbl.className = "table table-bordered";
                Tbl.style.background = "#d8d1e5";
                //Tbl.style.width = "50%";
                //Tbl.style.float = "right";

                const Thead = Tbl.createTHead();
                const tbody = Tbl.createTBody();
                var hrow = Thead.insertRow(0);
                var cell = hrow.insertCell(0);
                cell.innerHTML = "Dashboard";

                var cell1 = hrow.insertCell(1);
                cell1.innerHTML = "Link";



                for (var i = 0; i < result.Response.out_put.length; i++) {
                    const hrow1 = tbody.insertRow(0);
                    var hcell = hrow1.insertCell(0);
                    hcell.innerHTML = result.Response.out_put[i].Dashboard_Name;

                    var hcell1 = hrow1.insertCell(1);
                    //hcell1.innerHTML = "Link";
                    var ahtml: HTMLAnchorElement = document.createElement('a');
                    ahtml.href = "javascript:void(0)";
                    ahtml.target = '_blank';
                    ahtml.innerHTML = result.Response.out_put[i].Link;
                    hcell1.appendChild(ahtml);
                }


                boxText.appendChild(Tbl);
                MainboxText.append(boxText);



                const SpanText = document.createElement("span");
                SpanText.innerHTML = todaysDataTime;
                SpanText.className = "time_date";

                boxText.appendChild(SpanText);

                MainboxText.append(boxText);


                this.renderer.appendChild(this.divView.nativeElement, MainboxText);


                const MainboxTextCMsg2: HTMLDivElement = document.createElement("div");
                MainboxTextCMsg2.className = "outgoing_msg";

                const boxTextCMsg2: HTMLDivElement = document.createElement("div");
                boxTextCMsg2.className = "sent_msg";

                var ahtml: HTMLAnchorElement = document.createElement('a');
                ahtml.href = "javascript:void(0)";
                ahtml.innerHTML = "For more queries click here";
                ahtml.addEventListener('click', (e) => {
                    this.startChat(Chattext, "", 4);//your typescript function
                });

                boxTextCMsg2.appendChild(ahtml);

                MainboxTextCMsg2.append(boxTextCMsg2);

                this.renderer.appendChild(this.divView.nativeElement, MainboxTextCMsg2);


            }

            //returns results if demographic exists
            else if ((result.Response.Query_flag == 5) && (result.Response.HR_flag == 0)) {
                for (var i = 0; i < result.Response.Selkey.length; i++) {
                    this.tmpDemographicList = result.Response;
                    if (i == 0) {
                        const MainboxTextCMsg: HTMLDivElement = document.createElement("div");
                        MainboxTextCMsg.className = "outgoing_msg";

                        const boxTextCMsg: HTMLDivElement = document.createElement("div");
                        boxTextCMsg.className = "sent_msg";

                        const PyesCMsg: HTMLParagraphElement = document.createElement('p');
                        PyesCMsg.innerHTML = "With " + result.Response.Selkey[i] + " do you mean";

                        boxTextCMsg.appendChild(PyesCMsg);

                        MainboxTextCMsg.append(boxTextCMsg);

                        this.renderer.appendChild(this.divView.nativeElement, MainboxTextCMsg);


                        const MainboxText: HTMLDivElement = document.createElement("div");
                        MainboxText.className = "outgoing_msg";

                        const boxText: HTMLDivElement = document.createElement("div");
                        boxText.className = "sentMsgOptions";

                        let FilterVariables = result.Response[result.Response.Selkey[i]];
                        for (var z = 0; z < FilterVariables.length; z++) {
                            const Pyes: HTMLParagraphElement = document.createElement('p');
                            Pyes.className = "pSentMsgOptions";
                            Pyes.innerHTML = FilterVariables[z];
                            Pyes.style.cursor = "pointer";

                            let tmp = FilterVariables[z];
                            let tmpkey = result.Response.Selkey[i]
                            Pyes.addEventListener('click', (e) => {

                                this.ArrSelDemo.push(tmpkey + '~' + tmp);
                                this.SaveDemographicValue(e, Chattext, tmp, i);//your typescript function
                            });
                            boxText.appendChild(Pyes);
                        }

                        MainboxText.append(boxText);

                        this.renderer.appendChild(this.divView.nativeElement, MainboxText);




                    }

                }
            }
            else {
                const MainboxTextCMsg: HTMLDivElement = document.createElement("div");
                MainboxTextCMsg.className = "outgoing_msg";

                const boxTextCMsg: HTMLDivElement = document.createElement("div");
                boxTextCMsg.className = "sent_msg";

                const PyesCMsg: HTMLParagraphElement = document.createElement('p');
                PyesCMsg.innerHTML = result.Response.out_put;

                boxTextCMsg.appendChild(PyesCMsg);

                const SpanText = document.createElement("span");
                SpanText.innerHTML = todaysDataTime;
                SpanText.className = "time_date";

                boxTextCMsg.appendChild(SpanText);


                MainboxTextCMsg.append(boxTextCMsg);

                this.renderer.appendChild(this.divView.nativeElement, MainboxTextCMsg);

            }

            this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollHeight;
            this.LoaderForChatBot = "none";
        },

            (error) => {
                this.LoaderForChatBot = "none";
            }
        );

    this.SeltextVal = "";
}


//Append market unit location
ShowGeoDTEPopup(event:any, user_query:any, Analysis:any) {
    event.stopPropagation();
    // this.SelFilter = "0";
    //this.dropdownList = [];
    this.SaveQuery = user_query;
    
    var arr = this.dropdownList;
    var target: any;
    // var target = a.some(function(el){ return el => el.SelDropdown=="Market unit location"});
    target = arr.filter((e: { SelDropdown: string; }) => e.SelDropdown == "Market unit location")


    if (target.length > 0) {

        this.SelFilter = 'Market unit location'
        this.GetFilterIcon();
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'col_name',
            textField: 'col_name',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 1,
            allowSearchFilter: true
        };


        this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollHeight;
        
    }
    else {
        let auth_token = "";

        this.api.GetDataForMarketlocation(auth_token, Analysis)
            .subscribe((result: any) => {

                this.MarketLocationList = result.MarketLoc;

                this.SelFilter = 'Market unit location'
                this.GetFilterIcon();


                this.dropdownSettings = {
                    singleSelection: false,
                    idField: 'col_name',
                    textField: 'col_name',
                    selectAllText: 'Select All',
                    unSelectAllText: 'UnSelect All',
                    itemsShowLimit: 1,
                    allowSearchFilter: true
                };
                this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollHeight;
                
            },

                (error) => {
                   
                }
            );
    }
    this.openModal(true);
    //this.ShowDiv('Charts');

}

//Hide market unit location
HideGeoDTEPopup(event :any, user_query:any, Analysis:any) {
    event.stopPropagation();
    this.cntrForChart = this.cntrForChart + 1;
    this.checkchange = "Changefromchatbot";
    this.ShowDiv('Charts');
    this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollHeight;
    //this.ShowDiv('Charts');

}

//Open and close popup for market unit location
openModal(open: boolean): void {
    this.mdlSampleIsOpen = open;
   // let auth_token = this.storage["msal.idtoken"];


}

MinMaxDiv() {
    if (this.showCharts == true) {

        if (this.ChatBotStyles.height == "500px") {
            this.ChartStyles = { 'marginLeft': '0%' };
            this.DisplayMesgs = "none";
            this.DisplayTypeMsg = "none";
            this.ChatBotStyles = {
                'height': '50px',
                'left': '0%',
                'width': '25%'
            }
        }
        else {
            this.DisplayMesgs = "block";
            this.DisplayTypeMsg = "block";
            this.ChatBotStyles = {
                'height': '500px',
                'left': '0%',
                'width': '25%'
            }
            this.ChartStyles = {
                'marginLeft': '25%'
            }

        }
    }
}


SelectOneValFromMultipleVal(e:any, Chattext:any, FrontInput:any) {

    // this.cntrForChart = this.cntrForChart + 1;
    //this.checkchange = "Changefromchatbot";
    e.target.style.background = "#ffffff";
    var dt = e.target.innerHTML;
    // this.SelFilter = "0";
    // this.dropdownList = [];
    this.startChat(Chattext, dt, "1");
}

SaveMarketUnitLocation(event:any) {
    event.stopPropagation();
    this.cntrForChart = this.cntrForChart + 1;
    this.checkchange = "Changefromchatbot";
    this.openModal(false);
    this.ShowDiv('Charts');

}


SaveDemographicValue(event:any, Chattext:any, FrontInput:any, cnt:any) {
    cnt++;

    if (cnt >= this.tmpDemographicList.Selkey.length) {
        var FinalSel = '';
        for (var i = 0; i < this.ArrSelDemo.length; i++) {
            FinalSel += this.ArrSelDemo[i] + '^';
        }

        this.startChat(Chattext, FinalSel, 3)
    }
    else {
        for (var i = 0; i < this.tmpDemographicList.Selkey.length; i++) {
            this.tmpDemographicList = this.tmpDemographicList.Selkey;
            if (i == cnt + 1) {
                const MainboxTextCMsg: HTMLDivElement = document.createElement("div");
                MainboxTextCMsg.className = "outgoing_msg";

                const boxTextCMsg: HTMLDivElement = document.createElement("div");
                boxTextCMsg.className = "sent_msg";

                const PyesCMsg: HTMLParagraphElement = document.createElement('p');
                PyesCMsg.innerHTML = "With " + this.tmpDemographicList.Selkey[i] + " do you mean";

                boxTextCMsg.appendChild(PyesCMsg);

                MainboxTextCMsg.append(boxTextCMsg);

                this.renderer.appendChild(this.divView.nativeElement, MainboxTextCMsg);


                const MainboxText: HTMLDivElement = document.createElement("div");
                MainboxText.className = "outgoing_msg";

                const boxText: HTMLDivElement = document.createElement("div");
                boxText.className = "sentMsgOptions";

                let FilterVariables = this.tmpDemographicList[this.tmpDemographicList.Selkey[i]];
                for (var z = 0; z < FilterVariables.length; z++) {
                    const Pyes: HTMLParagraphElement = document.createElement('p');
                    Pyes.className = "pSentMsgOptions";
                    Pyes.innerHTML = FilterVariables[z];
                    Pyes.style.cursor = "pointer";
                    let tmp = FilterVariables[z];
                    let tmpkey = this.tmpDemographicList.Selkey[i];
                    Pyes.addEventListener('click', (e) => {
                        this.ArrSelDemo.push(tmpkey + '~' + tmp);
                        this.SaveDemographicValue(e, Chattext, tmp, i);//your typescript function
                    });
                    boxText.appendChild(Pyes);
                }

                MainboxText.append(boxText);

                this.renderer.appendChild(this.divView.nativeElement, MainboxText);


            }
        }

    }
}


AppendInsight(txtInsight:any) {

    let todaysDataTime = formatDate(this.today, 'dd-MM-yyyy hh:mm:ss a', 'en-US', '+0530');

    const MainboxTextCMsg: HTMLDivElement = document.createElement("div");
    MainboxTextCMsg.className = "outgoing_msg";

    const boxTextCMsg: HTMLDivElement = document.createElement("div");
    boxTextCMsg.className = "sent_msg";

    const PyesCMsg: HTMLParagraphElement = document.createElement('p');
    PyesCMsg.innerHTML = txtInsight;

    boxTextCMsg.appendChild(PyesCMsg);

    const SpanText = document.createElement("span");
    SpanText.innerHTML = todaysDataTime;
    SpanText.className = "time_date";

    boxTextCMsg.appendChild(SpanText);


    MainboxTextCMsg.append(boxTextCMsg);

    let str = document.getElementsByClassName("msg_history")[0];
    // var parser = new DOMParser();
    // var doc = parser.parseFromString(str, 'text/html');
    //console.log("this.divView",this.divView,str)
    this.renderer.appendChild(str, MainboxTextCMsg);

    let lestr = document.getElementsByClassName("mesgs")[0];
    lestr.scrollTop = lestr.scrollHeight;

}


ShowMoreLess(len:any, InnerText:any) {
    if (InnerText == "See more") {
        var a_html = document.querySelectorAll(".a_bg")
        a_html[0].innerHTML = "See less";
        var div = Array.from(document.getElementsByClassName('pSentMsgOptions bg') as HTMLCollectionOf<HTMLElement>)
        for (var p = 0; p < div.length; p++) {
            //console.log("indise");
            div[p].style.display = "block";
        }
        this.a_InnerHtml = "See less";

        //div.style = 'block';
    }
    else {
        var a_html = document.querySelectorAll(".a_bg")
        a_html[0].innerHTML = "See more"
        var div = Array.from(document.getElementsByClassName('pSentMsgOptions bg') as HTMLCollectionOf<HTMLElement>)
        for (var p = 0; p < div.length; p++) {
            if (p > 4) {
                // console.log("outdise");
                div[p].style.display = "none";
            }
        }
        this.a_InnerHtml = "See more";
    }

    this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollHeight;
}





AppendBookmarkFilters(tl :any) {
    if (tl == "") {
        this.dropdownList = [];
        this.SelFilter = "0";
    }
    else {
        let FilterValue = tl.split(";")
        this.dropdownList = [];
        for (var i = 0; i < FilterValue.length; i++) {
            this.SelFilter = this.toTitleCase(FilterValue[i].split('~')[0]);
            let tmpFilterValue = FilterValue[i].split('~')[1];
            //console.log(tmpFilterValue);
            tmpFilterValue = tmpFilterValue.split(':');
            let eachFilterValue = [];
            for (var z = 0; z < tmpFilterValue.length; z++) {

                eachFilterValue.push({ "col_name": tmpFilterValue[z], "isDisabled": true });
            }
            this.ShowDelete = true;

            this.dropdownList.push({ "SelDropdown": this.SelFilter, "SelectedList": eachFilterValue, "selectedItems": eachFilterValue, "ShowDelete": this.ShowDelete, "FilterType": "Demographic" })
            //this.GetFilterIcon();
            this.dropdownSettings = {
                singleSelection: false,
                idField: 'col_name',
                textField: 'col_name',
                selectAllText: 'Select All',
                unSelectAllText: 'UnSelect All',
                itemsShowLimit: 1,
                allowSearchFilter: true
            };
        }
    }


}


//Show and Hide Filters
ShowFilterForUserSection() {
    this.FilterWidthMarginPosition.x = '230px';
    this.FilterWidthMarginPosition.y = '230px';
    this.ChartStyles = { 'marginLeft': '0%' };
    this.DisplayMesgs = "none";
    this.DisplayTypeMsg = "none";
    this.ChatBotStyles = {
        'height': '50px',
        'left': '0%',
        'width': '25%'
    }

}

AppendValueForUserSectionFilter(UserFilterValue:any) {
    this.dropdownList = [];
    let sentlist = ["Positive", "Negative", "Neutral"];
    this.UserData = true;
    this.SentimentList.push({ "SelDropdown": "Sentiments", "SelectedList": sentlist, "selectedItems": sentlist, "ShowDelete": true, "FilterType": "UserDefine" })
    this.FilterList = UserFilterValue;
    this.Sentimentdisabled = true;
    this.SentimentSettings = {
        singleSelection: false,
        // idField: 'col_name',
        // textField: 'col_name',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
    };
}

showLoader(){
    this.ShowLoader='block';
}

hideLoader(){
    this.ShowLoader='none';
}





}


